import { BaseOrderLine } from 'shared/models/base-order-line.model';

const isRtoOrder = (order: BaseOrderLine): boolean => {
  return 'RTO' === order.pmtType;
};

export default isRtoOrder;
